/** init domain config */
import Vue from 'vue';
import { bizPath } from '@/config/file.config';

// 设置全局API_BASE_URL
Vue.prototype.API_BASE_URL = process.env.VUE_APP_BASE_API.replace('http://', `${window.location.protocol}//`);
window._CONFIG['domianURL'] = Vue.prototype.API_BASE_URL;

// 设置 文件路径 全局变量
Vue.prototype.$bizPath = bizPath;
